
export const convertToColorFormat = (colorCode: string) => {
  // Convert color code to RGB format
  const hexToRgb = (hex: string) => {
      const bigint = parseInt(hex.slice(1), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `rgb(${r},${g},${b})`;
  };

  const rgbColor = hexToRgb(colorCode);

  // Create Color format string
  const colorFormat = `Color(${rgbColor})`;

  return colorFormat;
}

export function _convertToColorFormat(hexColor: string) {
  const colorFormat = `Color(0x${hexColor.replace("#", "")})`;
  return colorFormat;
}

export const convertToCssColor = (colorFormat: string) => {
  // Extract the hexadecimal color code from the Color format string
  const hexColor = colorFormat.replace(/^Color\(0x([a-fA-F0-9]+)\)$/i, "$1");

  // Convert the hexadecimal color code to a valid CSS color value
  const cssColor = `#${hexColor}`;
  
  return cssColor;
}
